<template lang="html">
  <div class="snapshots-scene">
    <div class="snapshots-title">
      {{ $tr('responses.snapshots') }}
    </div>
    <div class="snapshots">
      <div v-for="picture in snapshots" class="small-picture" >
        <div>
          <img :src="picture.preview" />
        </div>
      </div>
      <div v-if="emptyBlockNumber" v-for="i in (1, emptyBlockNumber)" class="small-picture"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'response-tabs-tab-snapshots',

  props: {
    snapshots: Array
  },

  computed: {
    emptyBlockNumber () {
      const remainder = this.snapshots.length % 4
      return remainder ? 4 - remainder : 0
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../../../styles/colors.scss';

  .snapshots-scene{
    padding-top: 24px;
    .snapshots-title {
      font-size: 16px;
      font-weight: bold;
    }

    .snapshots {
      padding-top: 24px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      justify-content: flex-;
      width: 100%;

      .small-picture {
        width: 24%;
        margin-bottom: 18px;
        div {
          img {
            width: 100%;
            max-width: 134px;
          }
        }
      }
    }
  }
</style>
